import { CallRouteService as PhoneHourService } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';
import { bindHTTP } from '@frontend/schema';

const SchemaPhoneHoursConfigService = bindHTTP(PhoneHourService);

export default SchemaPhoneHoursConfigService;
